const middleware = {}

middleware['guest'] = require('../middleware/guest.js')
middleware['guest'] = middleware['guest'].default || middleware['guest']

middleware['notes-context'] = require('../middleware/notes-context.js')
middleware['notes-context'] = middleware['notes-context'].default || middleware['notes-context']

export default middleware
